export enum ToggleAction {
    LOCK = 'LOCK',
    UNLOCK = 'UNLOCK',
}
